import "./styles.css";

const New = (type: { type: string }) => {
  return (
    <>
      {type.type === "menu" ? (
        <div className="new-menu">
          <span />
        </div>
      ) : type.type === "item" ? (
        <div className="new-item">novo</div>
      ) : (
        ""
      )}
    </>
  );
};

export default New;
